import type { RouteObject } from 'react-router-dom';

export const authRoutes: RouteObject[] = [
  { path: 'connexion', lazy: () => import('./LoginPage').then((m) => ({ Component: m.LoginPage })) },
  { path: 'inscription', lazy: () => import('./LoginPage').then((m) => ({ Component: m.SignupPage })) },
  { path: 'admin/connexion', lazy: () => import('./AdminLoginPage').then((m) => ({ Component: m.AdminLoginPage })) },
];
